// extracted by mini-css-extract-plugin
export default {"FormContainerText":"NewUserForm_FormContainerText__L4xtY","FormButtonWrapper":"NewUserForm_FormButtonWrapper__iIVRL"};